// extracted by mini-css-extract-plugin
export default {"container":"VoiceDetail_container__fTSRF","metadata_container":"VoiceDetail_metadata_container__lBfI2","audio":"VoiceDetail_audio__AW+X3"};